<!-- <template>
  <div class="click-pop">
    <div @click="toggleVisible" @click.stop>
      <slot></slot>
    </div>
    <transition name="fade-scale">
      <div v-show="visible" class="click-pop-box" @click="handleContentClick">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
// 闭包实现的ID生成器
const generateId = (() => {
  let id = 0
  return () => `click-pop-${Date.now()}-${id++}`
})()

export default {
  props: {
    isClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      instanceId: generateId() // 生成唯一实例ID
    }
  },
  methods: {
    toggleVisible(event) {
      event.stopPropagation()
      // 通知其他实例关闭（排除自己）
      this.$root.$emit('closeAllClickPop', this.instanceId)
      this.visible = !this.visible
    },
    close() {
      this.visible = false
    },
    handleContentClick(event) {
      if (this.isClose) {
        event.stopPropagation()
        this.close()
      }
    }
  },
  mounted() {
    // 监听全局关闭事件
    this.$root.$on('closeAllClickPop', (excludeId) => {
      if (this.instanceId !== excludeId) {
        this.close()
      }
    })
    document.addEventListener('click', this.close)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
    // 清理事件监听
    this.$root.$off('closeAllClickPop')
  }
}
</script>

<style lang="scss" scoped>
.click-pop{
  position: relative;
}

.click-pop-box {
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 399;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>   -->

<!-- 方案二 Vue 内部的_uid可能会造成潜在的内部属性变更风险 -->
<template>
  <div class="click-pop">
    <div @click="toggleVisible" @click.stop>
      <slot></slot>
    </div>
    <transition name="fade-scale">
      <div v-show="visible" class="click-pop-box" @click="handleContentClick">
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus'
export default {
  props: {
    isClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    toggleVisible(event) {
      if (this.$store.state.isLogin == 0) {
        eventBus.$emit('showLogin', {})
        return
      }
      event.stopPropagation()
      // 关闭其他所有实例
      this.$root.$emit('closeAllClickPop', this._uid)
      // 切换当前实例的显示状态
      this.visible = !this.visible
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleContentClick(event) {
      if (this.isClose) {
        event.stopPropagation()
        this.close()
      }
    },
  },
  mounted() {
    // 监听关闭所有实例的事件
    this.$root.$on('closeAllClickPop', excludeId => {
      if (this._uid !== excludeId) {
        this.close()
      }
    })
    document.addEventListener('click', this.close)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
    // 移除事件监听器防止内存泄漏
    this.$root.$off('closeAllClickPop')
  },
}
</script>

<style lang="scss" scoped>
.click-pop {
  position: relative;
}

.click-pop-box {
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 401;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
